import {Component, Input, OnChanges, OnInit} from '@angular/core';

import {Destroyable} from '../../../../destroyable.component';
import {
  EnrichedResponseDetail,
  ErrorDetails,
  MasterDataCallbackRequest
} from '../../sdconnect-ext.model';
import {PersonSdcResponse, SdcLogDTO} from '../../sdconnect.model';

@Component({
  selector: 'gp-sdc-person-feedback',
  templateUrl: './sdc-person-feedback.component.html'
})
export class SdcPersonFeedbackComponent extends Destroyable implements OnInit, OnChanges {

  @Input()
  public sdcLog: SdcLogDTO;

  public error: ErrorDetails = null;
  public enrichedResponses: EnrichedResponseDetail[] = [];

  ngOnInit() {
    this.extractHttpRespBody();
  }

  ngOnChanges() {
    this.extractHttpRespBody();
  }

  private extractHttpRespBody() {
    if (!this.sdcLog) {
      return;
    }
    if (this.sdcLog.httpRespBody) {
      const sdcLogHttpResponseBodyAsJson = JSON.parse(this.sdcLog.httpRespBody);
      if (this.isPersonSdcResponse(sdcLogHttpResponseBodyAsJson)) {
        this.enrichedResponses = sdcLogHttpResponseBodyAsJson.masterDataResponse?.responses;
        this.error = sdcLogHttpResponseBodyAsJson.errorResponse?.error;
      } else if (this.isMasterDataCallbackRequest(sdcLogHttpResponseBodyAsJson)) {
        this.enrichedResponses = sdcLogHttpResponseBodyAsJson.responses;
        if (!this.enrichedResponses || this.enrichedResponses.length === 0) {
          // fallback to error if no responses
          this.error = sdcLogHttpResponseBodyAsJson.error;
        }
      }
    }
  }

  private isPersonSdcResponse(value: any): value is PersonSdcResponse {
    return (
      typeof value === 'object' && value !== null
      && typeof value.status === 'number'
      && (typeof value.masterDataResponse === 'object' || typeof value.errorResponse === 'object')
    );
  }

  private isMasterDataCallbackRequest(value: any): value is MasterDataCallbackRequest {
    return (
      typeof value === 'object' && value !== null && typeof value.traceId === 'string'
    );
  }
}
